<template>
  <div>
    <NavbarNew></NavbarNew>
    <div class="container-fluid" style="margin-top:70px">
      <div class="row ml-0 mr-0">
        <!--<div class="col-lg-8 col-md-7">
      <edit-profile-form>

      </edit-profile-form>
    </div>
    <div class="col-lg-4 col-md-5">
      <user-card>

      </user-card>
        </div>-->
        <div class="col-lg col-md">
          <user-card class="borderless-card"></user-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import EditProfileForm from './UserProfile/EditProfileForm.vue'
import UserCard from "./UserProfile/UserCard.vue";
import NavbarNew from "../Layout/NavbarNew";
export default {
  components: {
    UserCard,
    NavbarNew
  },
  mounted() {
    this.$store.commit("todo/setCurrentComponent", "dashboard");
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Profile`;
  }
};
</script>
<style>
</style>
